import React, { useCallback, useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./Pages/Dashboard/Dashboard";
import ClientDashBoard from "./Pages/ClientDashboard/ClientDashboard";
import Login from "./Pages/Login";
import Signup from "./Pages/SingUp";
import Blank from "./Pages/BlankPage";
import OpportunityPage from "./Pages/OpportunityPage/OpportunityPage";
import KnowledgeCentrePage from "./Pages/KnowledgeCentre/KnowledgeCentrePage";
import Certificate from "./Pages/Certificate/Certificate";
import ReferEarn from "./Pages/ReferEarn/ReferPage";
import FaqPage from "./Pages/FaqPage/FaqPage";
import MarketingMaterial from "./Pages/MarketMaterial/MarketMaterialPage";
import ClientSupportPage from "./Pages/ClientSupport/ClientSupportPage";
import LedgerReportSidebar from "./Pages/Reports/LedgerReportSidebar";
import MorningLimits from "./Pages/Reports/MorningLimitsSidebar";
import ClienHolding from "./Pages/Reports/ClientHoldingSidebar";
import OnboardingSearchCard from "../src/Components/OnboardingSearchCard";
import ForgetEmail from "./Components/login/ForgetEmail";
import ChangePassword from "./Components/login/ChangePassword";
import ForgetPassword from "./Components/login/ForgetPassword";
import KnowledgeCenterDetailPage from "./Pages/KnowledgeCentre/KnowledgeCenterDetailPage";
import DividendSidebar from "./Pages/Reports/DividendSidebar";
import DpReportSidebar from "./Pages/Reports/DpReportSidebar";
import InterestReportSidebar from "./Pages/Reports/InterestReportSidebar";
import LeviesReportSidebar from "./Pages/Reports/LeviesReportSidebar";
import PnlReportSidebar from "./Pages/Reports/PnlReportSidebar";
import TaxReportSidebar from "./Pages/Reports/TaxReportSidebar";
import TradeSummaryReportSidebar from "./Pages/Reports/TradeSummaryReportSidebar";
import CombineLedgerReportSidebar from "./Pages/Reports/CombineLedgerReportSidebar";
import MTFDetailsReportSidebar from "./Pages/Reports/MTFDetailsReportSidebar";
import LTCGReportSidebar from "./Pages/Reports/LTCGReportSidebar";
import ContractListSidebar from "./Pages/Reports/ContractListSidebar";
import MTFDelayPaymentSideBarReport from "./Pages/Reports/MTFDelayPaymentSideBarReport";
import KnowledgeCenterModules from "./Pages/KnowledgeCentre/KnowledgeCenterModules";
import ClientDetailsOms from "./Pages/OMS/ClientDetailsOms/ClientDetailsOms";
import RejectionList from "./Pages/OMS/RejectionList/RejectionList";
import RmMapping from "./Pages/RmMapping/RmMapping";
import TelecallerDashboard from "./Pages/Telecaller/TelecallerDashboard";
import TeleCallerComp from "./TeleCallerUserComponent/TeleCallerComp";
import MainPage from "./Components/MainPage";
import OnboardingPendingNew from "./Pages/Onboarding/OnboardingPendingNew";
import HOME from "./Pages/OMS/OMS";
import ClientWiseAumReport from "./Pages/Reports/ClientWiseAumReport";
import ClientWiseRevenueReport from "./Pages/Reports/ClientWiseRevenueReport";
import SingleHoldingReport from "./Pages/Reports/SingleHoldingReportSidebar";
import HierarchyReport from "./Pages/Reports/HierarchyReport";
import TeleDashboard from "../src/TeleCallerUserComponent/TeleDashboard";
import ContactUs from "./Pages/ContactUs";
import AgingReportSidebar from "./Pages/Reports/AgingReportSidebar";
import ApMaster from "./Pages/ApMaster/ApMaster";
import PledgeReportSidebar from "./Pages/Reports/PledgeReportSidebar";
import SoaReportSidebar from "./Pages/Reports/SOAReportSidebar";
import IVRReport from "./Pages/Reports/IVRReport";
import GlobalLogin from "./Pages/GlobalLogin";
import RmsPayout from "./Pages/RmsPayout/RmsPayout";
import Banking from "./Pages/Banking/Banking";
import AccountRights from "./Pages/AccountRights/AccountRights";
import ApPayout from "./Pages/ApPayout/ApPayout";
import { useIdleTimer } from "./Components/login/LogoutTimer";
import ForgetTelecallerPassword from "./Components/login/ForgotTelecallerPassword";
import Telecaller360 from "./TeleCallerUserComponent/Telecaller360";
import MarginReport from "./Pages/Reports/MarginReportSidebar";
import TentativeMarginReportSidebar from "./Pages/Reports/TentativeMarginReportSidebar";
import RecordingReport from "./CallRecording/RecordingReport";
import CallRecordingReport from "./CallRecording/CallRecordingReport";
import IncomeDeclartionSidebar from "./Pages/Reports/IncomeDeclartionSidebar";
import PackUpgrade from "./TeleCallerUserComponent/PackUpgrade";
import FundTransactionReportSidebar from "./Pages/Reports/FundTransactionReportSidebar";
import CostReportTradeSIdebar from "./Pages/Reports/CostReportTradeSIdebar";
import Last10TransactionTradeSidebar from "./Pages/Reports/Last10TransactionTradeSidebar";
import PartnerAdminDashboard from "./Pages/PartnerAdminDashboard/PartnerPersonalDetails/PartnerAdminDashboard";
import PartnerApplicationStatus from "./Pages/PartnerBackoffice/PartnerApplicationStatus/PartnerApplicationStatus";
import Invoice from "./Pages/PartnerAdminDashboard/partnerAdminInvoice/AdminInvoice";
import PartnerOnboardingDashboard from "./Pages/PartnerBackoffice/PartnerOnboardingDashboard/PartnerOnboardingDashboard";
import PartnerDetailsDashboard from "./Pages/PartnerAdminDashboard/PartnerPersonalDetails/PartnerAdminDetailsDashboard";
import PartnerInvoice from "./Pages/PartnerSideJourney/PartnerInvoice";
import PartnerSideDashboard from "./Pages/PartnerSideJourney/PartnerSideDashboard/PartnerSideDashboard";
import ReferralLink from "./Pages/PartnerSideJourney/ReferralLink";
import RevenueReport from "./Pages/Reports/RevenueReport";
import FamilyMaster from "./Pages/FamilyMaster/FamilyMaster";
import IPOMaster from "./Pages/IpoMaster/IpoMaster";
import PartnerSideContactUs from "./Pages/PartnerSideJourney/PartnerSideContactUs";
import FrenchiseeApplicationStatus from "./Pages/FrenchiseeBackoffice/FrenchiseeApplicationStatus";
import PersonalDetailsDashboard from "./Pages/PartnerAdminDashboard/PartnerPersonalDetails/PersonalAdminDetailsDashboard";
import YieldReportSidebar from "./Pages/Reports/YieldReportSidebar";
import PartnerAdminOnboardingDashboard from "./Pages/PartnerAdminDashboard/PartnerAdminOnboardingDashboard/PartnerAdminOnboardingDashboard";
import PledgeMasterReportSidebar from "./Pages/Reports/PledgeMasterReportSidebar";
import OmsHni from "./Pages/OmsHNI/OmsHni";
import RejectionListOmsHni from "./Pages/OmsHNI/RejectionListOmsHni/RejectionListOmsHni";
import ClientDetailsOmsHni from "./Pages/OmsHNI/ClientDetailsOmsHni/ClientDetailsOmsHni";
import ComplianceDashboard from "./Pages/ComplianceDashboard/ComplianceDashboard";
import ComplianceApplicationStatusDashboard from "./Pages/ComplianceDashboard/ComplianceApplicationStatusDashboard";
import PartnerDashboardPage from "./Pages/PartnerAdminDashboard/PartnerDashboardPage";
import FranchiseeOnboardingDashboard from "./Pages/FrenchiseeBackoffice/FrenchiseOnboardingDashboard/FranchiseeOnboardingDashboard";
import FreezeUnfreezePage from "./Pages/FreezeUnfreezePage/FreezeUnfreeze";
import AdminOverview from "./Pages/IBAAdmin/AdminOverview";
import AgentDetails from "./Pages/IBAAdmin/AgentDetails";
import PayoutApproval from "./Pages/IBAAdmin/PayoutApproval";
import TelecallerMerge from "./TeleCallerUserComponent/TelecallerAllMerge";
import TelecallerUpdated from "./TeleCallerUserComponent/TelecallerUpdated";
import IncomeTrackingPage from "./Pages/Reports/IncomeTrackingReportSidebar";
import AdminDashboardTabs from "./Pages/AdminPage/AdminDashboardTabs";
import SocialMediaBrokerageTabs from "./Pages/Brokerage/SocialMediaBrokerageTabs";
import TelecallerHni from "./Pages/HniTelecaller/TelecallerHni";
import HNITelecallerUpdated from "./Pages/HniTelecaller/HniTelecallerNewPage";
import HniDashboardTabs from "./Pages/HniTelecaller/HniDashboardTabs";
import HniTelecallerNewPage from "./Pages/HniTelecaller/HniTelecallerNewPage";
// import { esopBaseURL } from "./Configuration/API_URL";
import ClientFnoLoss from "./Pages/ClientFnoLoss/ClientFnoLoss";
import { esopBaseURL } from "./Configuration/API_URL";
import MtfPosReportSidebar from "./Pages/Reports/MtfPosReportSidebar";
import Hierarchy from "./Pages/Hierarchy/Hierarchy";
import FnoDeliveryReport from "./Pages/Reports/FnoDeliveryReport";
import MutualFunds from "./Pages/MutualFunds/MutualFunds";
// import LeadAllTabs from "./Pages/LeadCreation/LeadAllTabs";
import GlobalReport from "./Pages/Reports/GlobalReport"
import MFReports from "./Pages/MFReports/MFReports";
import OverviewPage from "./Pages/IBA/Pages/Overview/OverviewPage";
import IbaAgentDetails from "./Pages/IBA/Pages/IbaAgentDetails/IbaAgentDetails";
import IbaPayoutApproval from "./Pages/IBA/Pages/IbaPayoutApproval/IbaPayoutApproval";
import IbaHoldPayout from "./Pages/IBA/Pages/IbaHoldPayout/IbaHoldPayout";
import LeadTabsWrapper from "./Pages/LeadCreation/LeadTabsWrapper";
import IPODocument from "./Pages/IPODocument/IPODocument";
import IbaPerformanceReports from "./Pages/IBA/Pages/IbaPerformanceReports/IbaPerformanceReports";
import MTFPMRReport from "./Pages/Reports/MTFPMRReport";
import CMLReport from "./Pages/Reports/CMLReport";
import AgtsReportSidebar from "./Pages/Reports/AgtsReportSidebar";
import SttReportSidebar from "./Pages/Reports/SttReportSidebar";
import ITRReportSidebar from "./Pages/Reports/ITRReportSidebar";
import PartnerPayoutWrapper from "./Pages/PartnerSideJourney/PartnerPayoutModule/PartnerPayoutWrapper";
import FinanceUpload from "./Pages/APLedger/FinanceUpload";
import APLedgerReport from "./Pages/APLedger/APLedgerReport";
import PartnerPayout from "./Pages/ApPayout/PartnerPayout";
import ItemisedMarginReportSidebar from "./Pages/Reports/ItemisedMarginReportSidebbar";
import IBAPersonalInsights from "./Pages/IBA/Pages/IbaPerformanceReports/IBAPersonalInsights";
import OverviewMainPage from "./Pages/IBA/Pages/Overview/OverviewMainPage";
import AdvanceTaxReport from "./Pages/Reports/AdvanceTaxReport";
import TelecallerIDUpdation from "./Pages/TelecallerIDUpdation/TelecallerIDUpdation";
import AgentPersonalDetailsComp from "./Pages/IBA/componentiba/AgentPersonalDetails/AgentPersonalDetailsComp";
import HufNreDetails from "./Pages/IBA/Pages/HufNreDetails/hufnreDetails";
import OffMarketMain from "./Pages/OffMarket/Maker/OffMarketMain";
import DealerMappingMain from "./Pages/DealerMapping/DealerMappingMain";
import MfElssReportSidebar from "./Pages/Reports/MfElssReportSidebar";
import MfCapitalGainReportSidebar from "./Pages/Reports/MfCapitalGainReportSidebar";
import MfFundHoldingReportSidebar from "./Pages/Reports/MfFundHoldingReportSidebar";
import MfTransactionHistoryReportSidebar from "./Pages/Reports/MfTransactionHistoryReportSidebar";
import AccrualReport from "./Pages/Reports/AccrualReport/AccrualReport";

function Routings() {

  const { pathname } = useLocation()

  useEffect(() => {
    let mode = localStorage.getItem("darkmode");
    let element = document.body;
    if (mode === "true") {
      element.classList.add("darkmode");
    } else {
      if (element.className.includes("darkmode")) {
        element.classList.remove("darkmode");
      }
    }
  }, []);

  const idleTimer = 180 * 60 * 1000; // 1 min
  const logout = useCallback(() => {
    const ssoToken = localStorage.getItem("ssoToken");
    if (ssoToken) {
      window.location.replace("/");
    } else {
      console.log("error logout token");
    }

    localStorage.clear();
    sessionStorage.clear();
  }, []);

  const RedirectComponent = () => {
    useEffect(() => {
      window.open(`${esopBaseURL}/esop-funding/`, "_self");
    }, []);

    return null;
  };

  useEffect(() => {
    console.log(pathname, "pathName");
    const accessedNav = JSON.parse(localStorage.getItem("endpoints"))
    // partner code added
    const partnerRoleNew = localStorage.getItem("partnerRoleNew");
    const accessedPartnerNav = JSON.parse(localStorage.getItem("PartnerEndpoints"))
    const globalAccess = ["/forgetTelecallerPassword", "/recoverUsername", "/", "/client-dashboard", "/partner-dashboard", "/partner-invoice", "/partner-details-dashboard", "/compliance-application", "/partner-application", "/onboarding", "/franchisee-application","/financeupload","/apledgerreport","/partner-payout","/leadcreation"]
    // partner code added
    if (partnerRoleNew === "Partner") {
      if (accessedPartnerNav?.includes(pathname) || globalAccess?.includes(pathname)) {
        // alert("partner allowed")
      }
      else if (accessedNav?.includes(pathname) || globalAccess?.includes(pathname)) {
        // alert("alloowed")
      } else {
        // alert("not aloows")
        window.location.replace("/");
      }

    }

  }, [pathname])
  useIdleTimer(logout, idleTimer);

   const EsopDealingRedirection = () => {
    useEffect(() => {
      window.open(`${esopBaseURL}/esop-dealer-terminal/`, "_self")
    },[]);
    return null;
  }
  
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Login />}></Route>
        <Route exact path="/sign-up" element={<Signup />}></Route>
        <Route
          exact
          path="/forgetPassword"
          element={<ForgetPassword />}
        ></Route>
        <Route
          exact
          path="/forgetTelecallerPassword"
          element={<ForgetTelecallerPassword />}
        ></Route>
        <Route exact path="/main" element={<MainPage />}></Route>
        <Route
          exact
          path="/changePassword"
          element={<ChangePassword />}
        ></Route>
        {pathname !== "/esop-funding/" &&
          <Route path="*" element={<Blank />} />
        }
        <Route path='/esop-funding/'
          element={<RedirectComponent />}>
        </Route>
        {pathname !== "/esop-dealer-terminal/" &&
          <Route path="*" element={<Blank />} />
        }
        <Route path='/esop-dealer-terminal/' element={<EsopDealingRedirection />}></Route>
        <Route exact path="/recoverUsername" element={<ForgetEmail />}></Route>
        <Route exact path="/dashboard" element={<Dashboard />}></Route>
        <Route
          exact
          path="/telecaller"
          element={<TelecallerDashboard />}
        ></Route>
        <Route exact path="/generatelink" element={<AdminDashboardTabs />} ></Route>
        <Route exact path="/approvebrokerage" element={<SocialMediaBrokerageTabs />} ></Route>
        <Route exact path="/leadcreation" element={<LeadTabsWrapper />} ></Route>

        <Route exact path="/ipodocument" element={<IPODocument/>}></Route>


         <Route exact path="/overview" element={<OverviewMainPage />}></Route>
        <Route exact path="/iba-agentDetails" element={<IbaAgentDetails />} ></Route>
        <Route exact path="/agent-personalDetails" element={<AgentPersonalDetailsComp />} ></Route>
        <Route exact path="/payout-approval" element={<IbaPayoutApproval/>}></Route>
        <Route exact path="/performance-reports" element={<IbaPerformanceReports/>}></Route> 
        <Route exact path="/personal-insight" element={<IBAPersonalInsights />}></Route> 

        {/* <Route exact path="/Telecaller360" element={<Telecaller360 />}></Route> */}
        {/* <Route exact path="/packupgrade" element={<PackUpgrade />}></Route> */}
        <Route
          exact
          path="/call-recording-report"
          element={<CallRecordingReport />}
        ></Route>
        <Route
          exact
          path="/call-download-Report"
          element={<RecordingReport />}
        ></Route>
        <Route
          exact
          path="/telecallerPage"
          element={<TelecallerUpdated />}
        ></Route>

        {/* <Route
          exact
          path="/telecallerPage"
          element={<TelecallerMerge />}
        ></Route> */}
        {/* <Route
          exact
          path="/telecallerHni"
          element={<TelecallerHni />}
        ></Route>  */}
        <Route
          exact
          path="/telecallerHni"
          element={<TelecallerHni />}
        ></Route>
        <Route
          exact
          path="/hniDashboard"
          element={<HniDashboardTabs />}
        ></Route>
        <Route
          exact
          path="/telecallerHniLead"
          element={<HniTelecallerNewPage />}
        ></Route>
        {/* HNITelecallerUpdated */}
        <Route
          exact
          path="/client-dashboard"
          element={<ClientDashBoard />}
        ></Route>
        <Route exact4 path="/opportunity" element={<OpportunityPage />}></Route>
        <Route
          exact
          path="/knowledge-center"
          element={<KnowledgeCentrePage />}
        ></Route>
        <Route exact path="/certificate" element={<Certificate />}></Route>
        <Route exact path="/refer-earn" element={<ReferEarn />}></Route>
        <Route
          exact
          path="/market-material"
          element={<MarketingMaterial />}
        ></Route>
        <Route exact path="/FAQ'S" element={<FaqPage />}></Route>
        <Route
          exact
          path="/onboarding"
          // element={<OnboardingPending />}
          element={<OnboardingPendingNew />}
        ></Route>
        <Route
          exact
          path="/off-market"
          element={<OffMarketMain />}
        ></Route>
        <Route
          exact
          path="/dealer-mapping"
          element={<DealerMappingMain />}
        ></Route>
        <Route
          exact
          path="/client-support"
          element={<ClientSupportPage />}
        ></Route>
        <Route
          exact
          path="/search-result"
          element={<OnboardingSearchCard />}
        ></Route>
        <Route
          exact
          path="/freezeUnfreeze"
          element={<FreezeUnfreezePage />}
        ></Route>
        <>
          <Route
            exact
            path="/single-holding"
            element={<SingleHoldingReport />}
          ></Route>
          <Route
            exact
            path="/hierarchy-report"
            element={<HierarchyReport />}
          ></Route>
          <Route
            exact
            path="/aging-report"
            element={<AgingReportSidebar />}
          ></Route>
        </>
        <Route exact path="/revenue-report" element={<RevenueReport />}></Route>
        <Route exact path="/itr-report" element={<ITRReportSidebar />}></Route>
        <Route exact path="/advance-tax-report" element={<AdvanceTaxReport />}></Route>

        <Route
          exact
          path="/aum-report"
          element={<ClientWiseAumReport />}
        ></Route>
        <Route
          exact
          path="/clientwise-revenue-report"
          element={<ClientWiseRevenueReport />}
        ></Route>
        <Route
          exact
          path="/ledger-report"
          element={<LedgerReportSidebar />}
        ></Route>
        <Route
          exact
          path="/combine-ledger-report"
          element={<CombineLedgerReportSidebar />}
        ></Route>
        <Route
          exact
          path="/partner/combine-ledger-report"
          element={<CombineLedgerReportSidebar />}
        ></Route>
        <Route
          exact
          path="/tradeSummary-report"
          element={<TradeSummaryReportSidebar />}
        ></Route>
        <Route
          exact
          path="/partner/tradeSummary-report"
          element={<TradeSummaryReportSidebar />}
        ></Route>
        <Route exact path="/P&L-report" element={<PnlReportSidebar />}></Route>
        <Route
          exact
          path="/partner/P&L-report"
          element={<PnlReportSidebar />}
        ></Route>
        <Route
          exact
          path="/statement-report"
          element={<ContractListSidebar />}
        ></Route>
        {/* <Route
          exact
          path="/levies-report"
          element={<LeviesReportSidebar />}
        ></Route> */}
        <Route
          exact
          path="/dividend-report"
          element={<DividendSidebar />}
        ></Route>
        <Route exact path="/morning-limits" element={<MorningLimits />}></Route>
        <Route exact path="/client-holding" element={<ClienHolding />}></Route>
        <Route exact path="/globalreport" element={<GlobalReport />}></Route>
        <Route exact path="/cml-report" element={<CMLReport/>}></Route>
        <Route exact path="/agts-report" element={<AgtsReportSidebar/>}></Route>
        <Route exact path="/stt-report" element={<SttReportSidebar/>}></Route>

        <Route exact path="/mf-elss-report" element={<MfElssReportSidebar />}></Route>
        <Route exact path="/mf-capitalgain-report" element={<MfCapitalGainReportSidebar />}></Route>
        <Route exact path="/mf-fundholding-report" element={<MfFundHoldingReportSidebar />}></Route>
        <Route exact path="/mf-transaction-report" element={<MfTransactionHistoryReportSidebar />}></Route>
        <Route
          exact
          path="/partner/client-holding"
          element={<ClienHolding />}
        ></Route>
        <Route
          exact
          path="/daysToLongTerm-report"
          element={<LTCGReportSidebar />}
        ></Route>
        <Route
          exact
          path="/tentative-margin"
          element={<TentativeMarginReportSidebar />}
        ></Route>
        <Route
          exact
          path="/fund-transaction"
          element={<FundTransactionReportSidebar />}
        ></Route>
        <Route
          exact
          path="/cost-report"
          element={<CostReportTradeSIdebar />}
        ></Route>
        <Route
          exact
          path="/last-10-transaction-report"
          element={<Last10TransactionTradeSidebar />}
        ></Route>
        <Route
          exact
          path="/interest-report"
          element={<InterestReportSidebar />}
        ></Route>
        <Route
          exact
          path="/partner/interest-report"
          element={<InterestReportSidebar />}
        ></Route>
        <Route exact path="/tax-report" element={<TaxReportSidebar />}></Route>
        <Route
          exact
          path="/mtf-details-report"
          element={<MTFDetailsReportSidebar />}
        ></Route>
        <Route
          exact
          path="/partner/mtf-details-report"
          element={<MTFDetailsReportSidebar />}
        ></Route>
        <Route
          exact
          path="/pledge-master-report"
          element={<PledgeMasterReportSidebar />}
        ></Route>
        <Route
          exact
          path="/delaypayment-report"
          element={<MTFDelayPaymentSideBarReport />}
        ></Route>
        <Route
          exact
          path="/partner/delaypayment-report"
          element={<MTFDelayPaymentSideBarReport />}
        ></Route>
        <Route
          exact
          path="/margin-shortage-report"
          element={<MarginReport />}
        ></Route>
        <Route
          exact
          path="/fnodelivery"
          element={<FnoDeliveryReport />}
        ></Route>
        <Route exact path="/mtfpos" element={<MtfPosReportSidebar />}></Route>
        <Route exact path="/fno-loss" element={<ClientFnoLoss />}></Route>
        <Route exact path="/pledge" element={<PledgeReportSidebar />}></Route>
        {/* <Route exact path="/soa-report" element={<SoaReportSidebar />}></Route> */}
        {/* <Route exact path="/ivr-report" element={<IVRReport />}></Route> */}
        <Route
          exact
          path="/income-declaration"
          element={<IncomeDeclartionSidebar />}
        ></Route>
        <Route
          exact
          path="/dp-transaction-report"
          element={<DpReportSidebar />}
        ></Route>
        <Route
          exact
          path="/income-tracking"
          element={<IncomeTrackingPage />}
        ></Route>
        <Route
          exact
          path="/partner/dp-transaction-report"
          element={<DpReportSidebar />}
        ></Route>
        <Route
          exact
          path="/yield-report"
          element={<YieldReportSidebar />}
        ></Route>
        <Route
          exact
          path="/knowledge-centre"
          element={<KnowledgeCenterDetailPage />}
        ></Route>
        <Route
          exact
          path="/knowledgeCentre-module"
          element={<KnowledgeCenterModules />}
        ></Route>
        {/* OMS Retail Routes start */}
        <Route exact path="/retail-home" element={<HOME />}></Route>
        <Route
          exact
          path="/retail-client-details"
          element={<ClientDetailsOms />}
        ></Route>
        <Route
          exact
          path="/retail-rejected-list"
          element={<RejectionList />}
        ></Route>
        {/* OMS Retail Routes end */}
        {/* OMS HNI Routes start */}
        <Route exact path="/hni-home" element={<OmsHni />}></Route>
        <Route
          exact
          path="/hni-client-details"
          element={<ClientDetailsOmsHni />}
        ></Route>
        <Route
          exact
          path="/hni-rejected-list"
          element={<RejectionListOmsHni />}
        ></Route>
        {/* OMS HNI Routes END */}
        <Route exact path="/rm-mapping" element={<RmMapping />}></Route>
        <Route exact path="/ap-master" element={<ApMaster />}></Route>
        <Route exact path="/ap-payout" element={<ApPayout />}></Route>
        <Route exact path="/partner-payout" element={<PartnerPayout />}></Route>
        <Route exact path="/rms" element={<RmsPayout />}></Route>
        <Route exact path="/family-master" element={<FamilyMaster />}></Route>
        <Route exact path="/ipo-master" element={<IPOMaster />}></Route>
        <Route exact path="/contact-us" element={<ContactUs />}></Route>
        <Route exact path="/banking" element={<Banking />}></Route>
        <Route exact path="/finance-rights" element={<AccountRights />}></Route>
        {/* partner onboarding */}
        <Route
          exact
          path="/application-review"
          element={<PartnerOnboardingDashboard />}
        ></Route>
        <Route
          exact
          path="/partner-application"
          element={<PartnerApplicationStatus />}
        ></Route>
        {/* partner side  */}
        <Route
          exact
          path="/partner-side-dashboard"
          element={<PartnerSideDashboard />}
        ></Route>
        <Route
          exact
          path="/partner-invoice"
          element={<PartnerInvoice />}
        ></Route>
        <Route exact path="/referral-link" element={<ReferralLink />}></Route>
        <Route
          exact
          path="/partner-side-contact-us"
          element={<PartnerSideContactUs />}
        ></Route>
        {/* frenchisee backoffice */}
        <Route
          exact
          path="/franchisee-onboarding"
          element={<FranchiseeOnboardingDashboard />}
        ></Route>
        <Route
          exact
          path="/franchisee-application"
          element={<FrenchiseeApplicationStatus />}
        ></Route>
        {/* partner admin routing */}
        <Route
          exact
          path="/partner-admin-dashboard"
          element={<PartnerAdminDashboard />}
        ></Route>
        <Route exact path="/invoice" element={<Invoice />}></Route>
        <Route
          exact
          path="/partner-details-dashboard"
          element={<PartnerDetailsDashboard />}
        ></Route>
        <Route
          exact
          path="/partner-master"
          element={<PartnerPayoutWrapper />}
        ></Route>
        <Route
          exact
          path="/personal-details"
          element={<PersonalDetailsDashboard />}
        ></Route>
        <Route
          exact
          path="/partner-admin-onboarding"
          element={<PartnerAdminOnboardingDashboard />}
        ></Route>
        <Route
          exact
          path="/partner-dashboard"
          element={<PartnerDashboardPage />}
        ></Route>
        {/* Compliance Dashboard routing */}
        <Route
          exact
          path="/compliance-dashboard"
          element={<ComplianceDashboard />}
        ></Route>
        <Route
          exact
          path="/compliance-application"
          element={<ComplianceApplicationStatusDashboard />}
        ></Route>
        {/* iba-routes */}
        <Route
          exact
          path="/payoutApproval"
          element={<PayoutApproval />}
        ></Route>
        <Route exact path="/hierarchy" element={<Hierarchy />}></Route>
        <Route exact path="/mutualfunds" element={< MutualFunds />}></Route>
        <Route exact path="/mfreports" element={< MFReports />}></Route>
        <Route exact path="/agentPerformance" element={<ContactUs />}></Route>
        <Route exact path="/communicationHub" element={<ContactUs />}></Route>
        <Route
          exact
          path="/trainingRepository"
          element={<ContactUs />}
        ></Route>{" "}
        <Route exact path="/overview" element={<AdminOverview />}></Route>
        {/* <Route exact path="/agentDetails" element={<AgentDetails />}></Route> */}
        <Route exact path="/mtfpmrreport" element={<MTFPMRReport />}></Route>
        <Route exact path="/financeupload" element={<FinanceUpload />}></Route>
        <Route exact path="/apledgerreport" element={<APLedgerReport />}></Route>
        <Route
          exact
          path="/itemised-margin-report"
          element={<ItemisedMarginReportSidebar />}
        ></Route> 
        <Route path="/telecaller-id-update" element={<TelecallerIDUpdation />} />
        <Route exact path="/hufnre-application-dashboard" element={<HufNreDetails />} ></Route>
        <Route path="/accrual-charges" element={<AccrualReport />} />
      </Routes>
    </>
  );
}

export default Routings;
